export default {
  APPLY_SEARCH_FILTERS: 'APPLY_SEARCH_FILTERS',
  APPLY_CICS_FILTERS: 'APPLY_CICS_FILTERS',
  SET_CICS_FILTERS: 'SET_CICS_FILTERS',
  CLEAR_ANALYTICS: 'CLEAR_ANALYTICS',
  CLEAR_FILES: 'CLEAR_FILES',
  CLEAR_FRAGRANCES: 'CLEAR_FRAGRANCES',
  CLEAR_CONCEPTS: 'CLEAR_CONCEPTS',
  CLEAR_STUDY_SUMMARIES: 'CLEAR_STUDY_SUMMARIES',
  RESET_CICS_FILTERS: 'RESET_CICS_FILTERS',
  RESET_SEARCH_FILTERS: 'RESET_SEARCH_FILTERS',
  SET_ANALYTICS_DATA: 'SET_ANALYTICS_DATA',
  SET_CICS: 'SET_CICS',
  SET_FILES: 'SET_FILES',
  SET_JOB_ID: 'SET_JOB_ID',
  SET_FRAGRANCES: 'SET_FRAGRANCES',
  SET_FRAGRANCES_DETAILS: 'SET_FRAGRANCES_DETAILS',
  SET_CONCEPTS: 'SET_CONCEPTS',
  SET_CONCEPTS_DETAILS: 'SET_CONCEPTS_DETAILS',
  SET_QUESTIONS: 'SET_QUESTIONS',
  SET_SAVED_SEARCHES: 'SET_SAVED_SEARCHES',
  SET_SEARCH_FIELDS: 'SET_SEARCH_FIELDS',
  SET_SEARCH_FILTERS: 'SET_SEARCH_FILTERS',
  SET_STUDIES_COUNT: 'SET_STUDIES_COUNT',
  SET_STUDY_DETAILS: 'SET_STUDY_DETAILS',
  SET_STUDY_ERROR: 'SET_STUDY_ERROR',
  SET_STUDY_SUMMARIES: 'SET_STUDY_SUMMARIES',
  SET_STUDY_TAGS: 'SET_STUDY_TAGS',
  UPDATE_STUDY_DETAILS: 'UPDATE_STUDY_DETAILS',
  SET_SIGNIFICANCE_RESULTS: 'SET_SIGNIFICANCE_RESULTS'
}
